import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Seo } from "@/lib/seo";
import { PageHero } from "@/components/page-hero";
import { Reveal } from "@/lib/motion";
import { SERVICIOS } from "@/content/services";
import { CONCIERGE_LEGAL, CTAS } from "@/content/site";

export default function Servicios() {
  return (
    <>
      <Seo
        title="Servicios"
        description="Siete áreas de práctica —negocios, patrimonio, familia, laboral, seguros, consumo y digital— y Concierge Legal, un nivel exclusivo para quienes dirigen."
        path="/servicios"
      />
      <PageHero
        eyebrow="Explora por servicio"
        titulo="Siete áreas, un mismo estándar"
        lead="Si ya sabes qué tipo de asunto tienes, entra directo al área que corresponde. Cada página explica qué incluimos, para quién es y cómo funciona."
      />
      <section className="bg-parchment">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 sm:py-24">
          <div className="grid gap-x-16 md:grid-cols-2">
            {[0, 1].map((col) => (
              <div key={col} className={col === 1 ? "md:mt-24" : ""}>
                {SERVICIOS.filter((_, i) => i % 2 === col).map((s) => (
                  <Reveal key={s.slug} y={16}>
                    <Link
                      to={`/servicios/${s.slug}`}
                      data-testid={`servicios-link-${s.slug}`}
                      className="group block border-t border-hairline py-8 transition-colors last:border-b hover:bg-parchment-surface/70"
                    >
                      <div className="flex items-start justify-between gap-6">
                        <div>
                          <p className="font-mono text-[11px] tracking-[0.22em] text-azul">
                            {String(SERVICIOS.indexOf(s) + 1).padStart(2, "0")}
                          </p>
                          <h2 className="mt-2 font-serif text-2xl text-ink-deep sm:text-3xl">{s.nombre}</h2>
                          <p className="mt-2 max-w-md text-sm leading-relaxed text-ink-muted">{s.frase}</p>
                        </div>
                        <ArrowUpRight className="mt-2 h-5 w-5 shrink-0 text-ink-muted transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-azul" />
                      </div>
                    </Link>
                  </Reveal>
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-ink-deep text-parchment" data-testid="servicios-concierge-section">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 sm:py-24">
          <div className="grid gap-12 lg:grid-cols-12">
            <div className="lg:col-span-7">
              <Reveal y={16}>
                <p className="eyebrow mb-5 text-salvia-marco">{CONCIERGE_LEGAL.eyebrow}</p>
                <h2 className="max-w-xl font-serif text-3xl leading-[1.1] tracking-tight sm:text-4xl lg:text-5xl">
                  {CONCIERGE_LEGAL.titulo}
                </h2>
                <p className="mt-6 max-w-xl text-base leading-relaxed text-parchment/70 sm:text-lg">
                  {CONCIERGE_LEGAL.desc}
                </p>
              </Reveal>
            </div>
            <div className="lg:col-span-5">
              <Reveal delay={0.1}>
                <ul className="border-t border-parchment/20">
                  {CONCIERGE_LEGAL.puntos.map((punto, i) => (
                    <li
                      key={i}
                      className="flex gap-5 border-b border-parchment/20 py-5"
                      data-testid={`servicios-concierge-punto-${i + 1}`}
                    >
                      <span className="font-mono text-xs text-salvia-marco">{String(i + 1).padStart(2, "0")}</span>
                      <p className="text-sm leading-relaxed text-parchment/85">{punto}</p>
                    </li>
                  ))}
                </ul>
                <Link
                  to={CTAS.prioritaria.href}
                  data-testid="servicios-concierge-prioritaria"
                  className="mt-10 inline-flex items-center justify-center gap-2 rounded-md border border-parchment/40 px-6 py-3 text-sm font-medium text-parchment transition-all duration-200 hover:bg-parchment/10 active:scale-[0.98]"
                >
                  {CTAS.prioritaria.label}
                  <ArrowUpRight className="h-4 w-4" />
                </Link>
                <p className="mt-4 font-mono text-xs leading-relaxed text-parchment/60">{CONCIERGE_LEGAL.nota}</p>
              </Reveal>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
